





























































import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class URippleTable extends Vue {
  // Required Props
  @Prop({ required: true })
  public data!: any[];

  // Optional props
  @Prop({ default: "u-ripple-table" })
  public tableClass!: string;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public isPaginated!: boolean;

  @Prop({ default: false })
  public isContained!: boolean;

  @Prop({ default: false })
  public isNarrow!: boolean;

  @Prop({ default: 10 })
  public limit!: number;

  @Prop({ default: 0 })
  public total!: number;

  @Prop({ default: 1 })
  public currentPage!: number;

  @Prop({ default: true })
  public isHoverable!: boolean;

  @Prop({ default: false })
  public isSquashed!: boolean;

  @Prop({ default: true })
  public showTotal!: boolean;

  @Prop({ default: false })
  public isCompact!: boolean;

  @Prop({ default: true })
  public showNoResultsMessage!: boolean;

  // Methods
  public onPageChange(page) {
    const newPage = page > 0 ? page : 1;
    this.$emit("page-change", newPage);
    this.$emit("update:currentPage", newPage);
  }

  public onLimitChange(limit) {
    this.$emit("limit-change", limit);
    this.$emit("update:limit", limit);
  }
}
